module.exports = __webpack_public_path__ + "img/americanas.4986e9e0.png";